import { toast } from 'react-toastify';

import useSyncMutation from '../useSyncMutation';

import { useLanguageContext } from '~providers';
import { postRequest } from '~services';
import { MutateContext, PaymentInfoRequest } from '~types';
import { getPaymentMutationErrorMessage } from '~utils/payment.util';

export const useMutationSavePaymentInfo = ({
  shouldToast = true,
  onErrorCallback,
}: MutateContext & { onErrorCallback?: (errorMsg: string) => void }) => {
  const { lt } = useLanguageContext();

  return useSyncMutation(
    (paymentInfo: PaymentInfoRequest) => {
      return postRequest({
        path: 'api/payment/update-payment-method',
        data: paymentInfo,
      });
    },
    {
      onError(error) {
        const message = getPaymentMutationErrorMessage({
          error,
          fallbackTextId: 'text.hooks.useMutationSavePaymentInfo.error',
          fallbackText: 'Something went wrong when save payment info',
          lt,
        });

        if (shouldToast) {
          toast.error(message);
        }

        onErrorCallback?.(message);
      },
      onSuccess() {
        if (shouldToast) {
          toast.success(
            lt(
              'text.hooks.useMutationSavePaymentInfo.success',
              'Save payment info success!',
            ),
          );
        }
      },
    },
  );
};
